import { render } from "./AdminSubmissionViewer.vue?vue&type=template&id=1d0621ce&scoped=true&ts=true"
import script from "./AdminSubmissionViewer.vue?vue&type=script&lang=ts"
export * from "./AdminSubmissionViewer.vue?vue&type=script&lang=ts"

import "./AdminSubmissionViewer.vue?vue&type=style&index=0&id=1d0621ce&scoped=true&lang=css"

import exportComponent from "/builds/project/shmu/shmu/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d0621ce"]])

export default __exports__